import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTimeKeepingSummaryStart,
  getTimeKeepingSummarySuccess,
  getTimeKeepingSummaryFailed,
} from "../redux/getTimeKeepingSummary";
import { getTimeKeepingSummaryApi } from "core/http/service/timeKeeping";

function* getTimeKeepingSummaryWork(action) {
  const { payload } = action;
  try {
    const res = yield call(getTimeKeepingSummaryApi, payload);

    yield put({
      type: getTimeKeepingSummarySuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getTimeKeepingSummaryFailed.type,
    });
  }
}

function* watchGetTimeKeepingSummary() {
  yield takeLatest(getTimeKeepingSummaryStart.type, getTimeKeepingSummaryWork);
}

export default function* getTimeKeepingSummarySaga() {
  yield all([watchGetTimeKeepingSummary()]);
}
